export default __webpack_public_path__ + "static/media/gold@2x.1580cae1.png";